import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from './auth/authSlice';

import companyReducer from './modules/company/companySlice';
import dashboardReducer from './modules/dashboard/dashboardSlice';
import pushnotificationReducer from './modules/pushnotification/pushnotificationSlice';
import splashReducer from './modules/splashSlice';
import { splashMiddleware } from './middleware/splashMiddleware';
import { fetchSplashData } from './modules/splashSlice';
import adminuserReducer from './modules/adminuser/adminuserSlice';
import adminroleReducer from './modules/adminrole/adminroleSlice';

import profileReducer from './modules/profile/profileSlice';
import customerReducer from './modules/customer/customerSlice';
import supplierReducer from './modules/supplier/supplierSlice';
import itemReducer from './modules/item/itemSlice';
import productionChargeReducer from './modules/productioncharge/productionchargeSlice';
import vatGroupReducer from './modules/vatgroup/vatgroupSlice';
import postingGroupReducer from './modules/postinggroup/postinggroupSlice';
import measurementUnitReducer from './modules/measurementunit/measurementunitSlice';
import itemGroupReducer from './modules/itemgroup/itemgroupSlice';
import brandReducer from './modules/brand/brandSlice';
import locationReducer from './modules/location/locationSlice';
import customerlocationReducer from './modules/customerlocation/customerlocationSlice';
import currencyReducer from './modules/currency/currencySlice';
import categoryReducer from './modules/category/categorySlice';
import subCategoryReducer from './modules/subcategory/subcategorySlice';
import purchaseInvoiceReducer from './modules/purchaseinvoice/purchaseinvoiceSlice';
import jobenquiryReducer from './modules/jobenquiry/jobenquirySlice';
import allJobOrderReducer from './modules/alljoborder/alljoborderSlice';
import jobOrderReducer from './modules/joborder/joborderSlice';
import joborderlpoReducer from './modules/joborderlpo/joborderlpoSlice';
import stockIssueReducer from './modules/stockissue/stockissueSlice';
import stockAdjustmentReducer from './modules/stockadjustment/stockadjustmentSlice';
import tailorReducer from './modules/tailor/tailorSlice';
import cuttingMasterReducer from './modules/cuttingmaster/cuttingmasterSlice';
import dailyProductionReducer from './modules/dailyproduction/dailyproductionSlice';
import jobCostingReducer from './modules/jobcosting/jobcostingSlice';
import cashMemoReducer from './modules/cashmemo/cashmemoSlice';
import cashMemoDirectReducer from './modules/cashmemodirect/cashmemodirectSlice';
import deliveryNoteReducer from './modules/deliverynote/deliverynoteSlice';
import saleInvoiceReducer from './modules/saleinvoice/saleinvoiceSlice';
import cashReceiptReducer from './modules/cashreceipt/cashreceiptSlice';
import producedItemReducer from './modules/produceditem/produceditemSlice';
import paymentallocationReducer from './modules/paymentallocation/paymentallocationSlice';


import reportpurchaseregisterReducer from './modules/reportpurchaseregister/reportpurchaseregisterSlice';
import reportorderstatusReducer from './modules/reportorderstatus/reportorderstatusSlice';
import reportitemproductionReducer from './modules/reportitemproduction/reportitemproductionSlice';
import reportitemproductioncostingReducer from './modules/reportitemproductioncosting/reportitemproductioncostingSlice';
import reporttailorworkReducer from './modules/reporttailorwork/reporttailorworkSlice';
import reportjobordercustomerlocationReducer from './modules/reportjobordercustomerlocation/reportjobordercustomerlocationSlice';
import reportjoborderReducer from './modules/reportjoborder/reportjoborderSlice';
import reportdeliverynoteReducer from './modules/reportdeliverynote/reportdeliverynoteSlice';
import reportstockledgerReducer from './modules/reportstockledger/reportstockledgerSlice';
import reportitemledgerReducer from './modules/reportitemledger/reportitemledgerSlice';
import reportdailytransactionsReducer from './modules/reportdailytransactions/reportdailytransactionsSlice';
import reportmonthlyperformanceReducer from './modules/reportmonthlyperformance/reportmonthlyperformanceSlice';
import reportsalesReducer from './modules/reportsales/reportsalesSlice';
import reportjoborderreversalReducer from './modules/reportjoborderreversal/reportjoborderreversalSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        company: companyReducer,
        splash: splashReducer,
        adminuser: adminuserReducer,
        adminrole: adminroleReducer,

        dashboard: dashboardReducer,
        pushnotification: pushnotificationReducer,
        customer: customerReducer,
        profile: profileReducer,
        supplier: supplierReducer,
        item: itemReducer,
        productioncharge: productionChargeReducer,
        vatgroup: vatGroupReducer,
        postinggroup: postingGroupReducer,
        measurementunit: measurementUnitReducer,
        itemgroup: itemGroupReducer,
        brand: brandReducer,
        location: locationReducer,
        customerlocation: customerlocationReducer,
        currency: currencyReducer,
        category: categoryReducer,
        subcategory: subCategoryReducer,
        purchaseinvoice: purchaseInvoiceReducer,
        jobenquiry: jobenquiryReducer,
        alljoborder: allJobOrderReducer,
        joborder: jobOrderReducer,
        joborderlpo: joborderlpoReducer,
        stockissue: stockIssueReducer,
        stockadjustment: stockAdjustmentReducer,
        tailor: tailorReducer,
        cuttingmaster: cuttingMasterReducer,
        dailyproduction: dailyProductionReducer,
        jobcosting: jobCostingReducer,
        cashmemo: cashMemoReducer,
        cashmemodirect: cashMemoDirectReducer,
        deliverynote: deliveryNoteReducer,
        saleinvoice: saleInvoiceReducer,
        cashreceipt: cashReceiptReducer,
        produceditem: producedItemReducer,
        paymentallocation: paymentallocationReducer,

        reportpurchaseregister: reportpurchaseregisterReducer,
        reportorderstatus: reportorderstatusReducer,
        reportitemproduction: reportitemproductionReducer,
        reportitemproductioncosting: reportitemproductioncostingReducer,
        reporttailorwork: reporttailorworkReducer,
        reportjobordercustomerlocation: reportjobordercustomerlocationReducer,
        reportjoborder: reportjoborderReducer,
        reportdeliverynote: reportdeliverynoteReducer,
        reportstockledger: reportstockledgerReducer,
        reportitemledger: reportitemledgerReducer,
        reportdailytransactions: reportdailytransactionsReducer,
        reportmonthlyperformance: reportmonthlyperformanceReducer,
        reportsales: reportsalesReducer,
        reportjoborderreversal: reportjoborderreversalReducer,
    },
    middleware: (getDefaultMiddleware) => 
        getDefaultMiddleware().concat(splashMiddleware)
});

// Dispatch splash data fetch on store initialization
store.dispatch(fetchSplashData());